import { Button } from '@mui/material';
import { ApplicationStatus, ServiceStatus } from '@prisma/client';

export const UpdateStatusButton = ({
    handleClick,
    title,
    status,
    icon,
    disabled,
}: {
    handleClick: (status: ApplicationStatus) => void;
    title: string;
    status: ApplicationStatus | ServiceStatus;
    icon: JSX.Element;
    disabled?: boolean;
}) => {
    return (
        <Button
            startIcon={icon}
            variant="npi-primary"
            type="button"
            sx={{ color: 'white' }}
            disabled={disabled}
            onClick={() => {
                return handleClick(status);
            }}
        >
            {title}
        </Button>
    );
};
